import { Space } from '@sravni/react-design-system';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { AdaptiveCard } from 'shared/ui/AdaptiveCard';
import { AdaptiveTitleText } from 'shared/ui/AdaptiveText';
import { CircleProgress } from 'shared/ui/CircleProgress';

import { userScoreSelector } from '../../model/userScore.selectors';

import { ScoringWlTexts } from './ScoringWl.texts';

export const ScoringWl: FC = ({ className }) => {
  const { score } = useSelector(userScoreSelector);
  return (
    <AdaptiveCard
      mobileSize={16}
      className={className}
    >
      <Space
        size={4}
        align="center"
        justify="space-between"
      >
        <AdaptiveTitleText
          range={[12, 14]}
          strong={false}
        >
          {ScoringWlTexts.description.map((text) => (
            <Fragment key={text}>
              {text} <br />
            </Fragment>
          ))}
        </AdaptiveTitleText>

        <CircleProgress
          value={score}
          maxValue={1000}
          size="small"
          className="h-color-G100"
        />
      </Space>
    </AdaptiveCard>
  );
};
